import React, { useState , useEffect }  from 'react';
import CounterUp from './CounterGlobal';
import WOW from "wowjs";


function AboutTwo() {
    useEffect(() => {
        const wow = new WOW.WOW({
          live: false, // This disables continuous scanning for new elements
        });
        wow.init();
      }, []);
  return (
    <div>
        
        {/* Start About Area  */}
        <div className="about-area about-style-two tmp-section-gapBottom">
            <div className="container">
            <div className="row align-items-center">
                <div
                className="col-lg-6">
                <div className="about-thumbnails about-style-two">
                    <img src="assets/images/about/about-style-4.png" alt="Business Consulting about" className="wow zoomIn" data-wow-duration=".8s" data-wow-delay=".3s"/>
                    <div className="dots animated tada">
                    <img
                        className="tada"
                        src="assets/images/about/dots.png"
                        alt="Business Consulting dots"
                    />
                    </div>
                    <div className="scater">
                    <img
                        src="assets/images/about/scater.png"
                        alt="Business Consulting scater"
                    />
                    </div>
                    <div className="tmpk__circle v__1">
                    <svg className="spinner" viewBox="0 0 100 100">
                        <defs>
                        <path
                            id="circle"
                            d="M50,50 m-37,0a37,37 0 1,1 74,0a37,37 0 1,1 -74,0"
                        />
                        </defs>
                        <text>
                        <textPath xlinkHref="#circle">
                            From Audits to ERP – Complete Solutions for Your Business Growth
                        </textPath>
                        </text>
                    </svg>
                    <div className="tmpk__circle--icon">
                        <i className="fa-light fa-arrow-right" />
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-6">
                <div className="inner">
                    <div className="section-head section-head-one-side text-align-left">
                    <div className="section-sub-title color-secondary">
                        <span className="subtitle">About Us</span>
                    </div>
                    <h2 className="title split-collab">
                        Discover how AQ Audit supports  <br /> your business consulting
                    </h2>
                    </div>
                    <p style={{textAlign:"justify"}} className="description">
                    At AQ Audit, we specialize in audit, accounting, and strategic consulting. Our expert team delivers tailored solutions in VAT compliance, ERP consulting, and business setup. Whether you're a startup or an established company, we provide insights and tools to improve your financial clarity and performance. With a commitment to precision and professionalism, we help you make confident business decisions and scale sustainably.
                    </p>
                    <div className="feature-counter">
                    <div className="tmp-feature-wrapper">
                        <h3 className="title">Grow Your Business</h3>
                        <div className="tmp-feature">
                        <div className="icon bg-color-secondary-alt radius-circle">
                            <i className="fa-regular fa-check small-icon" />
                        </div>
                        <div className="feature-content">
                            <h6 className="title">Trusted Audits</h6>
                        </div>
                        </div>
                        <div className="tmp-feature">
                        <div className="icon bg-color-secondary-alt radius-circle">
                            <i className="fa-regular fa-check small-icon" />
                        </div>
                        <div className="feature-content">
                            <h6 className="title">VAT Compliance</h6>
                        </div>
                        </div>
                        <div className="tmp-feature">
                        <div className="icon bg-color-secondary-alt radius-circle">
                            <i className="fa-regular fa-check small-icon" />
                        </div>
                        <div className="feature-content">
                            <h6 className="title">ERP Solutions</h6>
                        </div>
                        </div>
                        <div className="tmp-feature">
                        <div className="icon bg-color-secondary-alt radius-circle">
                            <i className="fa-regular fa-check small-icon" />
                        </div>
                        <div className="feature-content">
                            <h6 className="title">Accounting Services</h6>
                        </div>
                        </div>
                    </div>
                    {/* <div className="counter-wrapper counter-style-one">
                        <div className="counter-inner">
                            <CounterUp end={1560}/>
                        <p className="description">
                            Projects completed <br /> in last 5 years
                        </p>
                        </div>
                    </div> */}
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        {/* End About Area  */}

    </div>
  )
}

export default AboutTwo